import Shipments from '@mui/icons-material/UnarchiveOutlined';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import MyShipmentsSection from '@/sections/MyShipments/TableSection';

const MyShipments = () => {
  usePageTitle('Mis envíos');

  const { t } = useTranslation('myShipments');
  return (
    <Container maxWidth="xxl">
      <SectionTitle title={t('TITLE')} mt={5}>
        <Shipments fontSize="large" />
      </SectionTitle>

      <MyShipmentsSection />
    </Container>
  );
};

export default MyShipments;
